import axios from 'axios'
const BannersModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH: (state, payload) => {
      state.data = payload
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/portal/banners`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
    // getByOrderId: state => orderid => {
    //   return state.data.filter(item => item.idx === orderid)
    // },
    // getActive: state => {
    //   return state.data.filter(item => item.status === 'active')
    // }
  }
}

export default BannersModule
